module.exports = __webpack_public_path__ + "img/notifications/chrome-notifications-blocked-dea2a31a6543d34ba308e28d0504b803.png";